import type {
	AttachmentCapabilities,
	FileSourceStreamIdPair,
} from '@sharefiledev/request-list-pilet-sdk';
import { DefaultRequestListDataProvider } from '../PluginDataProvider/DefaultRequestListDataProvider';

export const attachmentCapabilities: AttachmentCapabilities = {
	bulkDeleteAttachments: (fileSourceStreamIdPairs: FileSourceStreamIdPair[]) =>
		DefaultRequestListDataProvider.bulkDeleteTaskAttachments(fileSourceStreamIdPairs),
	bulkRestoreAttachments: (fileSourceStreamIdPairs: FileSourceStreamIdPair[]) =>
		DefaultRequestListDataProvider.bulkRestoreTaskAttachments(fileSourceStreamIdPairs),
};
